import { Url } from "../../../constants/ApiUrlConstants";

export const FileDownload = async (id,name) => {
    try {
         let token = sessionStorage.getItem('TOKEN')
        
      const response = await fetch(Url.downloadIcsFile.replace('{mid}',id), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          "Authorization": "Bearer " + token,
          'X-CSRF-TOKEN' : 'YmUyYjAzODItOGIyZi00Njk1LThhOGMtYjhkYzVmZDY0YjI2'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.text();

      // Create a Blob from the response text
      const blob = new Blob([data], { type: 'text/calendar' });

      // Create a download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = name.replaceAll(" ","_")+".ics";
      link.click();
    } catch (error) {
      console.error('Error downloading .ics file:', error);
    }
  }; 